import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-furnitureshop-banner.js';

const buttonHtml = buttonPrimary({
  text: 'Buy now',
  backgroundColor: '#FF8100',
  color: '#FFFFFF',
  radius: 3,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85790b9a1e4455d92f0d2b.avif?w=200',
  },
  subBtn: { show: true, text: '🏆 Buy 5 Get 5 Free (10 Kits)' },
});

const contentHtml = `
  <div class="furnitureshop-banner container" data-attribute="furnitureshop-banner">
    <div class="furnitureshop-banner__content" data-attribute="furnitureshop-banner__content">
      <div class="furnitureshop-banner__tags">
        <span class="furnitureshop-banner__tag" data-attribute="furnitureshop-banner__tag">Deep Gloss</span>
        <span class="furnitureshop-banner__ceramic" data-attribute="furnitureshop-banner__ceramic">Ceramic</span>
      </div>
      <div
        class="furnitureshop-banner__headline"
        data-attribute="furnitureshop-banner__headline"
      >
        <h2>
          <span style="color:hsl(33,100%,94%);"><i><strong>CAR COATING KIT</strong></i></span>
        </h2>
        <p>Shield your car with professional-grade&nbsp;<br>coating against scratches and UV rays.</p>
      </div>
    </div>
    <div class="furnitureshop-banner__cta" data-attribute="furnitureshop-banner__cta">
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#050505',
  textColor: '#ffffff',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8578e9a16d69ac63743c6e.webp?w=1000',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8578f210322ac61e35bc54.webp?w=1000',
  topPadding: false,
  bottomPadding: false,
});
